import clsx from "clsx";
import { CSSProperties } from "react";

import styles from "./rlcard.module.scss";

type Props = {
  style?: CSSProperties;
  className?: string;
  "data-testid"?: string;
};
const RLCardContent: React.FC<Props> = ({
  children,
  style = {},
  className,
  "data-testid": dataTestId
}) => (
  <div
    className={clsx(styles.rlcard_content, className)}
    style={style}
    data-testid={dataTestId}
  >
    {children}
  </div>
);

export default RLCardContent;
